import {
  HttpErrorResponse,
  HttpEvent,
  HttpEventType,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment} from '@env/environment';
import {PROJECTS} from '@core/constants';

export const authInterceptor = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  return next(req).pipe(
    tap({
      next: (event: HttpEvent<any>) => {

        // if(environment.project === PROJECTS.BENEFICIARIES) {
        //   const pToken = (JSON.parse(sessionStorage.getItem('pToken')!) as { pToken: string }).pToken;
        //   if(pToken) {
        //     req.clone({
        //       headers: req.headers.set('pToken', 'pToken'),
        //     });
        //     //req.headers.set('pToken', pToken);
        //   }
        //
        // }
        if (event instanceof HttpResponse) {
        }
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 401) {
        }
      },
    })
  );
};
